import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { clearFilters } from "components/common/Filters/Filters.slice";
import NoDataBanner from "components/common/NoDataBanner";
import Typography from "components/common/Typography";
import { setCorpViewSelectedTab, setRecentlyViewed } from "components/features/Corp/CorpUser.Slice";
import { useTranslate } from "hooks/useTranslate";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { DEFAULT_CORP_INNCODE } from "utils/CommonConstants";
import { setSelectedMyList } from "utils/CommonFunctions";
import "../../../../../src/index.scss";
import { getUrl, recentlyViewedData } from "./RecentlyViewed";

interface Props {
  keyCategory: string;
  dataList: any;
  name?: string;
  inncode?: string;
  htlid?: string;
  urlId?: string;
}

const RecentData = (props: Props) => {
  const { keyCategory, dataList } = props;
  const { title, Icon, key1, key2 } = recentlyViewedData[keyCategory];
  const recentlyViewedCategory = useAppSelector((state) => state.CorpDashboard.recentlyViewedSelected.category);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const translate = useTranslate();

  const dataLength = dataList?.length > 2 ? "" : "no-data-banner";

  return (
    <Accordion className="view-recent-data-accordion" defaultExpanded={keyCategory === recentlyViewedCategory}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="view-recent-data-accordion-summary">
        <Typography variant="body2">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className={`view-recent-data-accordion-detail ${dataLength}`}>
        {dataList?.length > 0 ? (
          <>
            {dataList?.map((el: any) => {
              return (
                <div
                  style={{ display: "flex" }}
                  className="view-recent-data-wrapper"
                  onClick={() => {
                    navigate(getUrl(keyCategory, el), {
                      state: {
                        isMyLists: true,
                        defaultTab: 0,
                        fromDashboard: true,
                        innCode: DEFAULT_CORP_INNCODE
                      }
                    });
                    dispatch(setRecentlyViewed({ category: keyCategory, item: el[key1] }));
                    dispatch(clearFilters({ skipModified: true }));
                    if (keyCategory === "myList") {
                      setSelectedMyList(dispatch, el, el?.filterType);
                      dispatch(setCorpViewSelectedTab({ type: "myList", val: 0 }));
                    }
                  }}
                >
                  <div className="view-recent-data-icon">
                    <Icon />
                  </div>
                  <div className="view-recent-data-text">
                    <Typography variant={"body2"} className="ellipse-two">{`${el[key1]}`}</Typography>
                    {key2 !== null && (
                      <Typography variant={"body2"} showBold className="ellipse-one">
                        {`${el[key2]}`}
                      </Typography>
                    )}
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <div className="recently-viewed-no-data-banner">
            {" "}
            <NoDataBanner noDataMessage={`No Recently Viewed ${title}`} />
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
export default RecentData;
